import { Sector } from "@/types";
import { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { createContext } from "react";

export type ValidateCustomWebhookResponse = {
  data: {
    error: boolean;
    status?: number;
    url: string;
  };
};

export type UserSectorContextType = {
  sectorQuery: UseQueryResult<Sector, Error>;
  updateSectorCustomWebhook: UseMutationResult<
    ValidateCustomWebhookResponse,
    Error,
    Partial<Sector>,
    unknown
  >;
  activeSectorId: string | null;
  /**
   * O setor ativo já foi confirmado como um dos AccountAccess DESTE usuário
   * (SA-1277). Gate obrigatório para toda leitura que o backend autoriza contra
   * o setor ativo — ver `UserSectorProvider`.
   */
  isActiveSectorReady: boolean;
  /**
   * A conta ativa é um acesso de dev (SA-1482): a pessoa do time entrou numa
   * conta de cliente sem ser membro dela. Não é quem paga, então o gate de
   * billing não se aplica.
   */
  isDevAccessActive: boolean;
  setActiveSectorId: (id: string) => void;
};

export const UserSectorContext = createContext<
  UserSectorContextType | undefined
>(undefined);
